import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { blogItems } from "./comon/data";
import { Link } from "react-router-dom";

const Blog = () => {
    return (
        <React.Fragment>
            <section className="section bg-light" id="blog">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={7}>
                            <div className="text-center">
                                <h4 className="title-heading text-uppercase">Latest News</h4>
                                <p className="title-desc text-muted mt-3">Huge collection of elements, rich customization options, flexible layouts, stunning pages and instant results.</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        {(blogItems || []).map((item: any, index: number) => (
                            <Col lg={4} key={index}>
                                <div className="blog-menu mt-4">
                                    <img
                                        src={item.imageSrc}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div>
                                        <h4>
                                            <Link to="#" className="blog-title">
                                                {item.title}
                                            </Link>
                                        </h4>
                                        <p className="mt-2 text-muted">{item.description}</p>
                                        <div className="mt-3">
                                            <Link to="#" className="read-btn">
                                                Read More <i className="mdi mdi-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Blog;